import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { searchUtils } from '../../utils'
import './RadioButtonGroup.sass'


class RadioButtonGroup extends Component {
  constructor() {
    super()
    this._onChange = this.onChange.bind(this)
  }

  onChange(e) {
    const { setActiveFilterIds, activeFilterIds, options, onUpdate } = this.props
    const selectedFilterTermId = parseInt(e.target.value)
    const unselectedFilterTermIds = options.filter(option => option.id !== selectedFilterTermId).map(option => option.id)
    const updatedIds = searchUtils.getActiveFilterIds(activeFilterIds, [selectedFilterTermId], unselectedFilterTermIds)

    setActiveFilterIds(updatedIds)
    onUpdate(updatedIds)
  }

  render() {
    const { options, filterId, activeFilterIds, containerClassName, radioClassName } = this.props

    return (
      <fieldset className={containerClassName}>
        { options.map((option, idx) => (
            <div key={idx} className={radioClassName}>
              <input
                type="radio"
                checked={activeFilterIds.includes(option.id)}
                onChange={this._onChange}
                name={filterId}
                id={option.id}
                value={option.id}
              />
              <label htmlFor={option.id}>{option.name}</label>
            </div>
          ))
        }
      </fieldset>
    )
  }
}

RadioButtonGroup.propTypes = {
  options: PropTypes.array,
  filterId: PropTypes.number,
  setActiveFilterIds: PropTypes.func,
  activeFilterIds: PropTypes.array,
  onUpdate: PropTypes.func,
  containerClassName: PropTypes.string,
  radioClassName: PropTypes.string
}

RadioButtonGroup.defaultProps = {
  onUpdate: () => {},
  containerClassName: 'radio-group',
  radioClassName: 'checkbox-radio-green'
}

export default RadioButtonGroup
